
import { useEffect } from 'react';

/**
 * Enhanced domain redirect component with comprehensive logging
 * for deployment issue troubleshooting.
 * Now with specific handling for baabaa.app domain.
 */
const DomainRedirect = () => {
  useEffect(() => {
    // Only run on client-side
    if (typeof window === 'undefined') return;
    
    const currentHost = window.location.hostname;
    const currentUrl = window.location.href;
    const currentOrigin = window.location.origin;
    const currentPathname = window.location.pathname;
    const currentHash = window.location.hash;
    const currentSearch = window.location.search;
    
    console.log("DomainRedirect: Detailed environment info");
    console.log("DomainRedirect: Environment", process.env.NODE_ENV);
    console.log("DomainRedirect: URL", currentUrl);
    console.log("DomainRedirect: Origin", currentOrigin);
    console.log("DomainRedirect: Host", currentHost);
    console.log("DomainRedirect: Pathname", currentPathname);
    console.log("DomainRedirect: Hash", currentHash);
    console.log("DomainRedirect: Search", currentSearch);
    console.log("DomainRedirect: Document location", document.location.href);
    console.log("DomainRedirect: Base element", document.querySelector('base')?.href);
    
    // Test image loading from the root path
    const testImage = new Image();
    testImage.onload = () => console.log("DomainRedirect: Test image loaded successfully");
    testImage.onerror = (e) => console.error("DomainRedirect: Test image failed to load", e);
    testImage.src = `${currentOrigin}/favicon.ico?test=${Date.now()}`;
    
    // Special handling for baabaa.app domain
    if (currentHost === 'baabaa.app' || currentHost.endsWith('.baabaa.app')) {
      console.log("DomainRedirect: Detected baabaa.app domain");
    }
  }, []);

  // This component doesn't render anything
  return null;
};

export default DomainRedirect;
